module.exports = __webpack_public_path__ + "img/madrid_retiro.c40e8b6f.jpg";